import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

type DocCsvFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const DocCsvFilled = ({ size = 24, width, height, alt = '', color = 'currentColor', strokeWidth, style, ...props }: DocCsvFilledProps) =>
  h(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 24 24',
      fill: color,
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      color,
      "stroke-width": strokeWidth,
      style,
      ...props,
    },
    [
      h(
        'g',
        {
          transform: 'translate(-5.979997 -6.172914) scale(0.734375)',
        },
        [
          h(
            'path',
            {
              d: 'M26.4834 17.2461V8.74609H13.9834C13.1521 8.74609 12.4834 9.41484 12.4834 10.2461V39.2461C12.4834 40.0773 13.1521 40.7461 13.9834 40.7461H34.9834C35.8146 40.7461 36.4834 40.0773 36.4834 39.2461V18.7461H27.9834C27.1584 18.7461 26.4834 18.0711 26.4834 17.2461ZM20.4834 26.2461C20.4834 26.5223 20.2596 26.7461 19.9834 26.7461H19.4834C18.9309 26.7461 18.4834 27.1936 18.4834 27.7461V29.7461C18.4834 30.2986 18.9309 30.7461 19.4834 30.7461H19.9834C20.2596 30.7461 20.4834 30.9698 20.4834 31.2461V32.2461C20.4834 32.5223 20.2596 32.7461 19.9834 32.7461H19.4834C17.8265 32.7461 16.4834 31.403 16.4834 29.7461V27.7461C16.4834 26.0892 17.8265 24.7461 19.4834 24.7461H19.9834C20.2596 24.7461 20.4834 24.9698 20.4834 25.2461V26.2461ZM23.2503 32.7461H22.4834C22.2071 32.7461 21.9834 32.5223 21.9834 32.2461V31.2461C21.9834 30.9698 22.2071 30.7461 22.4834 30.7461H23.2503C23.6221 30.7461 23.9009 30.5273 23.9009 30.3323C23.9009 30.2511 23.854 30.1661 23.7684 30.0923L22.4003 28.9192C21.8709 28.468 21.5671 27.8267 21.5671 27.1605C21.5671 25.8292 22.7559 24.7467 24.2178 24.7467H24.9834C25.2596 24.7467 25.4834 24.9705 25.4834 25.2467V26.2467C25.4834 26.523 25.2596 26.7467 24.9834 26.7467H24.2165C23.8446 26.7467 23.5659 26.9655 23.5659 27.1605C23.5659 27.2417 23.6128 27.3267 23.6984 27.4005L25.0665 28.5736C25.5959 29.0248 25.8996 29.6661 25.8996 30.3323C25.9003 31.663 24.7121 32.7461 23.2503 32.7461ZM28.4834 25.2461V26.5461C28.4834 27.813 28.8396 29.0567 29.4834 30.1011C30.1271 29.0573 30.4834 27.813 30.4834 26.5461V25.2461C30.4834 24.9698 30.7071 24.7461 30.9834 24.7461H31.9834C32.2596 24.7461 32.4834 24.9698 32.4834 25.2461V26.5461C32.4834 28.7636 31.6784 30.8517 30.2159 32.4267C30.0271 32.6298 29.7615 32.7461 29.4834 32.7461C29.2053 32.7461 28.9396 32.6298 28.7509 32.4267C27.2884 30.8517 26.4834 28.7636 26.4834 26.5461V25.2461C26.4834 24.9698 26.7071 24.7461 26.9834 24.7461H27.9834C28.2596 24.7461 28.4834 24.9698 28.4834 25.2461ZM36.0459 15.3086L29.9271 9.18359C29.6459 8.90234 29.2646 8.74609 28.8646 8.74609H28.4834V16.7461H36.4834V16.3648C36.4834 15.9711 36.3271 15.5898 36.0459 15.3086Z',
            },
          ),
        ],
      ),
    ],
  );

export default DocCsvFilled;
